import { atom } from 'recoil';

export enum themeModeEnum {
  DARK_MODE = 'dark-mode',
  LIGHT_MODE = 'light-mode',
  SEMI_MODE = 'semi-mode',
}
const themeCookie =
  localStorage.getItem('themeMode') ?? themeModeEnum.LIGHT_MODE;
/**
 * Atom used to set theme mode (eg. dark-mode, light-mode, semi-mode)
 */
export const themeModeAtom = atom<themeModeEnum>({
  key: 'themeModeAtom', // unique ID (with respect to other atoms/selectors)
  default: themeCookie as any, // default value (aka initial value)
});
